var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirTankOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 68,
    viewBox: "0 0 51 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M19.16,45.45a1.908,1.908,0,0,1-1.91-1.9V31.61a1.91,1.91,0,0,1,3.82,0V43.55A1.908,1.908,0,0,1,19.16,45.45Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M19.16,30.03a1.583,1.583,0,0,1,1.58,1.58V43.55a1.58,1.58,0,1,1-3.16,0V31.61a1.583,1.583,0,0,1,1.58-1.58m0-.65a2.232,2.232,0,0,0-2.23,2.23V43.55a2.23,2.23,0,0,0,4.46,0V31.61a2.232,2.232,0,0,0-2.23-2.23Z",
    fill: "#404041"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M19.16,32.6A16.14,16.14,0,1,1,35.35,16.46,16.181,16.181,0,0,1,19.16,32.6Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M19.16.65A15.82,15.82,0,1,1,3.3,16.46,15.838,15.838,0,0,1,19.16.65m0-.65A16.46,16.46,0,1,0,35.67,16.46,16.51,16.51,0,0,0,19.16,0Z",
    fill: "#404041"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M7.91,26.68l-.77-1.04,2.92-2.14a11.468,11.468,0,1,1,20.78-6.71,11.32,11.32,0,0,1-2.08,6.57l2.73,2.17-.81,1.01-3.73-2.96.4-.51a10.045,10.045,0,0,0,2.19-6.29,10.18,10.18,0,1,0-18.06,6.43l.44.53Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 1.3,
    height: 4.82,
    transform: "translate(18.71 1.16)",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M29.63,13.03,29.2,11.8l4.13-1.45.44,1.22Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M9.01,12.49,4.9,11.04l.44-1.22,4.1,1.45Z",
    fill: "#8b90a0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M19.32,19.88a4.05,4.05,0,1,1,4.06-4.05A4.061,4.061,0,0,1,19.32,19.88Zm0-5.51a1.46,1.46,0,1,0,1.47,1.46A1.47,1.47,0,0,0,19.32,14.37Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M16.89,14.78a1.319,1.319,0,0,1-.94-.4L9.6,7.69a1.286,1.286,0,0,1,.05-1.83,1.307,1.307,0,0,1,1.84.05l6.35,6.68a1.3,1.3,0,0,1-.05,1.83A1.323,1.323,0,0,1,16.89,14.78Z",
    fill: "#231f20"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M50.68,52.48H47.94c-.24-5.97-1.72-10.57-3.53-10.57H5.84c-1.81,0-3.28,4.61-3.53,10.57H.32v3.41H2.31c.24,5.97,1.72,10.57,3.53,10.57H44.41c1.81,0,3.28-4.61,3.53-10.57h2.74Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M44.41,66.79H5.84c-2.29,0-3.59-5.42-3.84-10.57H0V52.16H2c.25-5.15,1.54-10.57,3.84-10.57H44.41c2.3,0,3.59,5.42,3.84,10.57H51v4.06H48.25C48,61.37,46.71,66.79,44.41,66.79ZM.65,55.57H2.63l.01.31c.26,6.42,1.84,10.26,3.2,10.26H44.41c1.34,0,2.94-3.92,3.2-10.26l.01-.31h2.72V52.81H47.62l-.01-.31c-.26-6.34-1.86-10.26-3.2-10.26H5.84c-1.37,0-2.94,3.84-3.2,10.26l-.01.31H.65Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M10.77,67.48h0a1.037,1.037,0,0,1-1.04-1.03V41.93a1.029,1.029,0,0,1,1.03-1.03h0a1.029,1.029,0,0,1,1.03,1.03V66.44A1.022,1.022,0,0,1,10.77,67.48Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M10.77,67.8a1.359,1.359,0,0,1-1.36-1.35V41.93a1.36,1.36,0,0,1,2.72,0V66.44A1.361,1.361,0,0,1,10.77,67.8Zm0-26.58a.713.713,0,0,0-.71.71V66.44a.71.71,0,0,0,1.42,0V41.93A.713.713,0,0,0,10.77,41.22Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M39.19,67.68h0a1.037,1.037,0,0,1-1.04-1.03V42.13a1.029,1.029,0,0,1,1.03-1.03h0a1.029,1.029,0,0,1,1.03,1.03V66.64A1.016,1.016,0,0,1,39.19,67.68Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M39.19,68a1.359,1.359,0,0,1-1.36-1.35V42.13a1.36,1.36,0,0,1,2.72,0V66.64A1.361,1.361,0,0,1,39.19,68Zm0-26.58a.713.713,0,0,0-.71.71V66.64a.71.71,0,1,0,1.42,0V42.13A.713.713,0,0,0,39.19,41.42Z",
    fill: "#404041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirTankOff);
export default __webpack_public_path__ + "static/media/air_tank_off.84a6a610f004f7413dc318c88179d0fa.svg";
export { ForwardRef as ReactComponent };